import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import PageHeader from '../components/PageHeader';
import { UserCircle } from 'lucide-react';
const CRM = () => {
  return <div className="flex h-screen bg-gray-50" data-id="element-1635">
      <div className="w-20 flex-shrink-0" data-id="element-1636">
        <Sidebar data-id="element-1637" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-1638">
        <Topbar data-id="element-1639" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-1640">
          <PageHeader title="CRM" subtitle="Customer Relationship Management" data-id="element-1641" />

          {/* Placeholder */}
          <div className="rounded-lg border border-gray-200 bg-white p-12" data-id="element-1642">
            <div className="text-center" data-id="element-1643">
              <UserCircle className="h-16 w-16 text-gray-300 mx-auto mb-4" data-id="element-1644" />
              <h2 className="text-xl font-semibold text-gray-700 mb-2" data-id="element-1645">CRM</h2>
              <p className="text-gray-500 max-w-md mx-auto" data-id="element-1646">
                Questa pagina conterrà il sistema CRM. Coming soon.
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>;
};
export default CRM;